module.exports = __webpack_public_path__ + "static/media/intro.d3f4ff68.jpeg";